/**
 * 嵌套路由，用来缓存一些页面组件.
 */
export default function() {
  return {
    name: 'subRouteView',
    // 组件名包含'alive'的才缓存
    template: `<keep-alive :include="/alive/i">
              <router-view></router-view>
            </keep-alive>`,
  }
}
